<template>
<div class="input-group input-group-outline mb-3">
    <label class="form-label">{{label}} {{id}}</label>
    <input
        type="text"
        v-model="txt"
        :class="'form-control ' + c_css"
        :maxlength="maxlength"
        :minlength="minlength"
        :autocomplete="autocomplete"
        @input="$emit('input', txt, id)"
        @focus="focused=!focused"
        @blur="focused=!focused"
        readonly="readonly"
        />
</div>
</template>
<script>
export default {
  props:{
    id:  { type: String , required: false, default: ''},   
    value : { type: String , required: false, default: ''},
    label: { type: String , required: false, default: ''},
    placeholder: { type: String, required: false, default: ''},
    c_css: { type: String, required: false, default: ''},
    maxlength: { type: String, required: false, default: ''},
    minlength: { type: String, required: false, default: ''},
    autocomplete: { type: String, required: false, default: ''},
  },
  mounted(){
    let input = this.$el.lastElementChild;
    setTimeout(() => {
      input.removeAttribute("readonly");
    }, 500);
  },
  data() {
    return {
      focused:  false,
      txt: null
    }
  }
}
</script>
